import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  checkboxContainer: {
    textAlign: 'left'
  },
  checkbox: {
    height: 'unset'
  },
  link: {
    color: theme.palette.secondary.main
  }
});

export default makeStyles(styles);
